import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';
import { TokenPairType } from '@api/types/models';

export type TokenPairSerializer = {
  email: string;
  password: string;
  ssoCode: string;
} & TokenPairType;

export type PostTokenPairPayloadType = (
  Pick<TokenPairSerializer, 'email' | 'password' | 'ssoCode'>
);
export type PostTokenPairResponseType = (
  Pick<TokenPairSerializer, 'access' | 'accessExpiresIn' | 'refresh' | 'refreshExpiresIn'>
);

export type PostRevokeTokenPairPayloadType = (
  Pick<TokenPairSerializer, 'refresh'>
);
export type PostRevokeTokenPairResponseType = {
  message: string;
};

export const apiGetTokenPair = ({
  payload,
  query,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostTokenPairPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.tokenPair(),
      payload,
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiRevokeTokenPair = ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostRevokeTokenPairPayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.tokenRevoke(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
